import LemaLogo from '@/assets/lema-icon.svg?url'
import { create } from '@bufbuild/protobuf'
import { useQuery } from '@connectrpc/connect-query'

import { getUserById } from '@/gen/customer/management/v1/service-CustomerManagementService_connectquery'
import { UserSchema } from '@/gen/customer/management/v1/service_pb'

const LemaActor = 'Lema'

export const useGetUserById = (userId?: string) => {
  const queryState = useQuery(
    getUserById,
    { userId },
    {
      enabled: userId !== LemaActor && !!userId,
      retry: false,
      retryOnMount: false,
    },
  )
  if (userId === LemaActor) {
    return {
      user: create(UserSchema, {
        id: LemaActor,
        name: LemaActor,
        avatarUrl: LemaLogo,
      }),
      isPending: false,
      isError: false,
    }
  }

  return {
    ...queryState,
    user: queryState.data?.user,
  }
}
